import Chart from 'chart.js';
import moment from 'moment';
moment.locale('fr');
moment.updateLocale('fr', {
  months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
  monthsShort: ["Janv.", "Févr.", "Mars", "Avr.", "Mai", "Juin", "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc."]
});
import Annotation from 'chartjs-plugin-annotation';
import Crosshair from 'chartjs-plugin-crosshair';
import DataLabels from 'chartjs-plugin-datalabels';

export default {
  data() {
    return {
      chart: null,
      chartData: [],
      chartIndex: -1,
      rangeInfos: [
        {
          label: '3A',
          size: 36,
          step: 12,
          borderWidth: 2
        },
        {
          label: '1A',
          size: 12,
          step: 4,
          borderWidth: 2
        },
        {
          label: '6M',
          size: 6,
          step: 2,
          borderWidth: 3
        },
        {
          label: '3M',
          size: 3,
          step: 1,
          borderWidth: 4
        },
        {
          label: '1M',
          size: 1,
          step: 1,
          borderWidth: 4
        },
        {
          label: '1S',
          size: 0,
          step: 0,
          borderWidth: 4
        }
      ],
      rangeStart: 4,
      rangeIndex: 3,
    }
  },
  computed: {
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel() {
      return this.getCultLabel();
    }
  },
  methods: {
    setRange(coursData) {
      this.rangeStart = 4;
      if (coursData) {
        var dateFirst = new Date(coursData[0][0] * 1000);
        var date = new Date(coursData[coursData.length - 1][0] * 1000);
        date.setDate(1);
        date.setMonth(date.getMonth() - 1);
        if (dateFirst < date.getTime()) {
          // show 3 mois
          this.rangeStart = 3;
        }
        date.setMonth(date.getMonth() - 2);
        if (dateFirst < date.getTime()) {
          // show 6 mois
          this.rangeStart = 2;
        }
        date.setMonth(date.getMonth() - 3);
        if (dateFirst < date.getTime()) {
          // show 12 mois
          this.rangeStart = 1;
        }
        date.setMonth(date.getMonth() - 6);
        if (dateFirst < date.getTime()) {
          // show 36 mois
          this.rangeStart = 0;
        }
      }
      if (this.rangeStart == 4) {
        this.rangeIndex = 3;
      } else {
        // rangeIndex >= rangeStart
        this.rangeIndex = Math.max(this.rangeStart, this.rangeIndex);
      }
    },
    initChart(coursData, alerte) {
      var coursChart = this.$el.querySelector('#coursChart');

      var timeFirst = new Date(coursData[0][0] * 1000).setDate(1);
      var date = new Date(coursData[coursData.length - 1][0] * 1000);

      var tickOffset = '           ';
      // TODO augmenter si > 3M
      var isOffsetLastTick = date.getDate() <= 5;
      var chartLabels = [];
      var timeStart;
      if (this.rangeInfos[this.rangeIndex].size == 1) {
        tickOffset = '  ';
        isOffsetLastTick = false;
        if (date.getDate() > 22) {
          date.setDate(22);
          timeStart = date.getTime();
          chartLabels.push(timeStart);
          date.setDate(15);
          timeStart = date.getTime();
          chartLabels.push(timeStart);
          date.setDate(8);
          timeStart = date.getTime();
          chartLabels.push(timeStart);
        } else if (date.getDate() > 15) {
          date.setDate(15);
          timeStart = date.getTime();
          chartLabels.push(timeStart);
          date.setDate(8);
          timeStart = date.getTime();
          chartLabels.push(timeStart);
        } else if (date.getDate() > 8) {
          date.setDate(8);
          timeStart = date.getTime();
          chartLabels.push(timeStart);
        } else if (date.getDate() == 1) {
          isOffsetLastTick = true;
        }
      }

      if (this.rangeInfos[this.rangeIndex].size) {
        date.setDate(1);
        if (this.rangeInfos[this.rangeIndex].size == 36) {
          date.setMonth(0);
        }
        timeStart = date.getTime();
        chartLabels.push(timeStart);
        for (let i = 1; i <= this.rangeInfos[this.rangeIndex].size; i++) {
          date.setMonth(date.getMonth() - 1);
          timeStart = date.getTime();
          if (timeStart <= timeFirst) {
            timeStart = timeFirst;
            break;
          }
          if (i % this.rangeInfos[this.rangeIndex].step == 0) {
            chartLabels.push(timeStart);
          }
        }
      } else {
        date.setDate(date.getDate() - 6 - date.getDay());
        timeStart = date.getTime();
        chartLabels.push(timeStart);
      }

      var chartTimeUnit = 'month';
      var chartTicksSource = 'labels';
      if (this.rangeInfos[this.rangeIndex].size == 36) {
        chartTimeUnit = 'year';
      } else if (this.rangeInfos[this.rangeIndex].size == 1) {
        chartTimeUnit = 'week';
        for (let i = 1; i < 4; i++) {
          chartLabels.push(timeStart + i * 7 * 24 * 60 * 60 * 1000);
        }
      } else if (!this.rangeInfos[this.rangeIndex].size) {
        chartLabels.push(timeStart + 7 * 24 * 60 * 60 * 1000);
      }

      var dataIndex = 0;
      this.chartData = [];
      var max, min;
      for (let i = 0; i < coursData.length; i++) {
        const item = coursData[i];
        const timeItem = item[0] * 1000;
        if (timeItem >= timeStart) {
          if (!this.chartData.length && timeItem != timeStart && timeStart != timeFirst) {
            // tick on first point
            chartLabels[chartLabels.length - 1] = timeItem;
          }
          this.chartData.push({
            x: timeItem,
            y: item[1]
          });
          if (max == undefined) {
            max = {
              index: [dataIndex],
              y: item[1]
            };
            min = {
              index: [dataIndex],
              y: item[1]
            };
          } else {
            if (item[1] > max.y) {
              max = {
                index: [dataIndex],
                y: item[1]
              };
            } else if (item[1] == max.y) {
              max.index.push(dataIndex);
            }
            if (item[1] < min.y) {
              min = {
                index: [dataIndex],
                y: item[1]
              };
            } else if (item[1] == min.y) {
              min.index.push(dataIndex);
            }
          }
          dataIndex += 1;
        }
      }
      if (Math.min.apply(null, max.index) < Math.min.apply(null, min.index)) {
        max.index = Math.min.apply(null, max.index);
        min.index = Math.max.apply(null, min.index);
      } else {
        min.index = Math.min.apply(null, min.index);
        max.index = Math.max.apply(null, max.index);
      }
      max.align = max.index / dataIndex > 0.5 ? 'left' : 'right';
      min.align = min.index / dataIndex > 0.5 ? 'left' : 'right';

      var chartOptions = {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: false,
            type: 'time',
            time: {
              unit: chartTimeUnit,
              displayFormats: {
                week: 'D',
                month: '1 MMM',
                year: 'MMM YYYY'
              }
            },
            ticks: {
              source: chartTicksSource,
              callback: function (value, index, values) {
                if (!index) {
                  return tickOffset + value;
                } else if (index == values.length - 1 && isOffsetLastTick) {
                  return value + tickOffset;
                } else {
                  return value;
                }
              }
            },
            afterBuildTicks: function (axis) {
              axis.margins.left = '-5px';
              axis.margins.right = '-5px';
            },
            gridLines: {
              display: false,
            }
          }],
          yAxes: [{
            display: false,
            ticks: {
              min: min.y - Math.ceil((max.y - min.y) / 20),
              max: max.y + Math.ceil((max.y - min.y) / 20),
              callback: function (value, index, values) {
                if (index < values.length - 1) {
                  return value/* + '€/t'*/;
                } else {
                  return null;
                }
              }
            }
          }]
        },
        events: ['touchstart', 'touchmove', 'touchend', 'mouseenter', 'mousemove', 'mouseout'],
        onHover: (event, el) => {
          if (event.type == 'touchend' || event.type == 'mouseout') {
            this.chartIndex = -1;
          } else if (el[0]) {
            this.chartIndex = el[0]._index;
          }
        },
        hover: {
          intersect: false,
          mode: 'index'
        },
        tooltips: {
          enabled: false,
          mode: 'index',
          intersect: false,
          /*
          custom : function(tooltipModel) {
            tooltipModel.opacity = 0;
          },
          */
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, data) {
              return tooltipItem.yLabel.toLocaleString('fr', { minimumFractionDigits: 2 }) + '€/t';
            }
          },
          titleFontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          titleFontSize: 18,
          bodyFontFamily: 'Rubik, Helvetica, Arial, sans-serif',
          bodyFontSize: 18,
          xPadding: 18,
          yPadding: 18
        },
        plugins: {
          crosshair: {
            line: {
              color: '#0c3c2b',  // --perfarmer-vert
              width: 3           // crosshair line width
            },
            sync: {
              enabled: false
            },
            zoom: {
              enabled: false
            }
          },
          datalabels: {
            display: function (context) {
              var index = context.dataIndex;
              return index == min.index || index == max.index;
            },
            formatter: function (value, context) {
              return (parseInt(value.y) == value.y ? value.y : value.y.toLocaleString('fr', { minimumFractionDigits: 2 })) + ' €/t';
            },
            align: function (context) {
              var index = context.dataIndex;
              if (index == min.index) {
                return min.align;
              } else if (index == max.index) {
                return max.align;
              }
            },
            color: 'black',
            font: {
              family: 'Rubik, Helvetica, Arial, sans-serif',
              size: 12,
              weight: 500
            },
            backgroundColor: 'white',
            borderRadius: 11,
            borderWidth: 1,
            borderColor: '#e6e8e8', // --perfarmer-gris-very-light
            padding: {
              top: 7,
              bottom: 7,
              left: 9,
              right: 9

            }/*,
            opacity: 0.8*/
          }
        }
      };

      if (alerte) {
        var annotationOption = {
          type: 'line',
          mode: 'horizontal',
          scaleID: 'y-axis-0',
          value: alerte,
          borderColor: '#e8612d', // --perfarmer-rouge
          borderWidth: 1,
          borderDash: [8, 6],
          borderDashOffset: 8,
          label: {
            enabled: true,
            xAdjust: 0,
            yAdjust: +15,
            fontFamily: 'Rubik, Helvetica, Arial, sans-serif',
            fontColor: '#e8612d', // --perfarmer-rouge
            fontSize: 15,
            fontStyle: 'normal',
            //fontWeight: 500,
            backgroundColor: 'transparent'
          }
        };
        chartOptions.annotation = {
          annotations: [JSON.parse(JSON.stringify(annotationOption)), JSON.parse(JSON.stringify(annotationOption))]
        };
        chartOptions.annotation.annotations[0].label.position = 'left';
        chartOptions.annotation.annotations[0].label.content = 'Mon alerte';
        chartOptions.annotation.annotations[1].label.position = 'right';
        chartOptions.annotation.annotations[1].label.content = alerte + ' €/t';
        chartOptions.scales.yAxes[0].ticks.min = Math.min(min.y, alerte) - Math.ceil((max.y - min.y) / 20);
        chartOptions.scales.yAxes[0].ticks.max = Math.max(max.y, alerte) + Math.ceil((max.y - min.y) / 20);
      }

      coursChart.width = this.$el.offsetWidth;
      coursChart.height = 
        this.$el.offsetHeight
        - (this.$el.hasAttribute('status-bar-fill') ? 20 : 0)
        - 44 /* toolbar */
        - 191 /* section */
        - 66 /* segment */;
      if (document.querySelector('html[onsflag-iphonex-portrait]')) {
        coursChart.height -= 34;
        if(! this.$el.hasAttribute('status-bar-fill')){
          coursChart.height -= 44;
        } else {
          coursChart.height -= 24;
        }
      }
      var ctx = coursChart.getContext('2d');
      if (this.chart) {
        this.chart.destroy();
        chartOptions.animation = { duration: 0 };
      }
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: chartLabels,
          datasets: [
            {
              data: this.chartData,
              pointRadius: 0,
              borderColor: '#ffc943', // --perfarmer-jaune
              fill: true,
              backgroundColor: 'white',
              pointHoverBorderColor: '#0c3c2b',  // --perfarmer-vert
              pointHoverBackgroundColor: '#0c3c2b4d',  // --perfarmer-vert opacity 0.3
              pointHoverBorderWidth: 3,
              pointHoverRadius: 8,
              borderWidth: this.rangeInfos[this.rangeIndex].borderWidth,
              lineTension: 0.2
            }
          ]
        },
        options: chartOptions
      });
    },
    formatDate(time) {
      return moment(new Date(time)).format('LL');
    }
  }
}